import { BaseService } from "./BaseService";
import { CommandService } from "./CommandService";
import { Configuration } from "Configuration";
import { IBaseGridDefinition, IMappingDefinition } from "Grids/Interfaces";
import { MappingDisplayType } from "Enums";

/**
 * Service for requesting gridDefinitions.
 * @hidden
 */
export class GridDefinitionService extends BaseService {

    /**
     * Get all gridDefinitions for a given mapping.
     * @param mappingName Name of the mapping.
     * @param displayType MappingDisplayType.
     */
    public getMapping(mappingName: string, displayType: MappingDisplayType = MappingDisplayType.FilterAndGrids): Promise<IMappingDefinition> {
        let param = CommandService.getContextParameters();
        let url = Configuration.baseUrl + "gridDefinition/" + mappingName;
        if (displayType != MappingDisplayType.FilterAndGrids) {
            url += "?mappingDisplayType=" + MappingDisplayType[displayType];
        }
        return this.post(url, param);
    }

    /**
     * Get a single gridDefinition by gridId.
     * @param gridId GridID.
     */
    public getGrid(mappingName: string, gridId: number): Promise<IBaseGridDefinition> {
        let param = CommandService.getRequestParameters();
        let url = `${Configuration.baseUrl}gridDefinition/${mappingName}/${gridId}`;
        return this.post(url, param);
    }
}